import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, Validators } from '@angular/forms';
import {
  IPerfilResponse,
} from 'src/app/perfis/model/interfaces-perfil';
import { IIncluirUsuarioDto } from '../model/iincluir-usuario-dto';
import { PerfisService } from 'src/app/perfis/perfis.service';
import { parseString } from 'xml2js';
import {IUsuarioArmazenamentoLocal} from "../model/usuario-sso-model";

@Component({
  selector: 'app-criar-usuario',
  templateUrl: './criar-usuario.component.html',
  styleUrls: ['./criar-usuario.component.scss'],
})
export class CriarUsuarioComponent implements OnInit{

  @Input() perfil: IPerfilResponse = {} as IPerfilResponse;
  @Output() emmitErros = new EventEmitter<Array<string>>();

  usuario!: IUsuarioArmazenamentoLocal;


  usuarioCtrl = this.fb.control(null, Validators.required);
  nomeCtrl = this.fb.control(null, Validators.required);
  emailCtrl = this.fb.control(null, [Validators.required, Validators.email]);
  dataNascimentoCtrl = this.fb.control(null, [Validators.required, this.adulto.bind(this)]);
  dddCtrl = this.fb.control(null, [Validators.required, Validators.maxLength(2), Validators.minLength(2), Validators.pattern('^[0-9]*$')]);
  telefoneCtrl = this.fb.control(null, [Validators.required ]);
  // perfilAcessoCtrl = this.fb.control(this.perfil.dscperfil, Validators.required);
  // cpfCtrl = this.fb.control(null, [Validators.required, Validators.maxLength(14)]);
  rgCtrl = this.fb.control(null, [Validators.required, Validators.minLength(9)]);
  orgaoEmissorCtrl = this.fb.control(null, Validators.required);
  dataEmissaoCtrl = this.fb.control(null, Validators.required);

  form  =  this.fb.group({
    usuario: this.usuarioCtrl,
    nome: this.nomeCtrl,
    email: this.emailCtrl,
    dataNascimento: this.dataNascimentoCtrl,
    ddd: this.dddCtrl,
    telefone: this.telefoneCtrl,
    // perfilAcesso: this.perfilAcessoCtrl,
    // cpf: this.cpfCtrl,
    rg: this.rgCtrl,
    orgaoEmissor: this.orgaoEmissorCtrl,
    dataEmissao: this.dataEmissaoCtrl,
  },{ update: 'blur' })


  constructor(
    private service: PerfisService,
    //private service: PerfisService,
    private fb: FormBuilder) {}
  ngOnInit(): void {
    this.getDadosUsuario();
  }
  getDadosUsuario() {
    try {
      this.service.getUsuarioLocalStorage().subscribe((r) => {
        this.usuario = r;
      });
    }catch {
      console.log('Erro ao buscar usuario');
  }
  }

  adulto(group: AbstractControl): ValidationErrors | null{

    const dataNascimentoControl = this.dataNascimentoCtrl?.value || 0;
    console.log(dataNascimentoControl);
    if (dataNascimentoControl) {
      const dataNascimento = new Date(dataNascimentoControl);
      const hoje = new Date();
      const idadeMinima = 18;
      const diffAnos = hoje.getFullYear() - dataNascimento.getFullYear();
      if (diffAnos > idadeMinima) {
        return null;
      }
    }
    return { adulto: true };
  }

  validarRG(): { rg: boolean } | null {
    const rgControl = this.form.get('rg');
    if (rgControl && rgControl.value) {
      const rg = rgControl.value;
      // Implement your validation logic here
      // Return true if the RG is valid, false otherwise

      return null;
    }
    return { rg: false };
  }



  criarUsuario() {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      return;
    }



    var  dto: IIncluirUsuarioDto = {
      DscLogin: this.usuarioCtrl.value,
      DscNome: this.nomeCtrl.value,
      DscEmail: this.emailCtrl.value,
      // DscIdentificacao: this.cpfCtrl.value, // mesmo q DscLogin
      NumDddFone: this.dddCtrl.value,
      NumFone: this.telefoneCtrl.value,
      DscExpedicaoRg: this.orgaoEmissorCtrl.value,
      DatExpedicaoRg: this.dataEmissaoCtrl.value,
      DatNascimento: this.dataNascimentoCtrl.value,
      NumRg: this.rgCtrl.value,
      CodPerfil: this.perfil.codperfil.toString(),
      Codentidade: 0,
      // Codsistema: 4, // nao precisa chumabo no codigo
      DscLoginEntidade: '1812',
    };

    this.service.addAusuarioNoPerfil(dto, this.usuario.guid).subscribe((r) => {
      if (r.sucesso) {
        //this.emmitErros.emit([]);
      } else {
        this.emmitErros.emit(r.mensagens);
      }
    });
  }
}
